/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReferralApi } from '../api/referrals.api';
import { switchMap, map } from 'rxjs/operators';
import { ReferralData, Referral } from '../../../interfaces/masters/referral';

@Injectable()
export class ReferralService extends ReferralData {

  constructor(private api: ReferralApi) {
    super();
  }


  list(url: string): Observable<Referral[]> {
    return this.api.list(url);
  }
  
  getByType(url: string,type:string,typeValue): Observable<Referral[]> {
    return this.api.getByType(url,type,typeValue);
  }

  getById(url:string): Observable<Referral>{
      return this.api.getById(url);
  }

  create(url: string, data:Referral): Observable<Referral> {
    return this.api.add(url,data);
  }

  update(url: string, data:Referral): Observable<Referral> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
